module.exports = __webpack_public_path__ + "static/img/partner-ykk.4caf3c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-ykk.png
// module id = smoM
// module chunks = 34